import { createFileRoute } from '@tanstack/react-router'

import { CampaignsPage } from '@/features/campaigns'
// Through `queries`, not the feature index: a loader is eager by construction.
import { campaignsListQuery } from '@/features/campaigns/queries'

export const Route = createFileRoute('/_auth/')({
  loader: ({ context }) => context.queryClient.ensureQueryData(campaignsListQuery()),
  component: CampaignsPage,
})
